import React from 'react';
import bandwidthStore from '../store/bandwidth';

const ProfileButton = (props) => {

  const onClickHandler = () => {
    bandwidthStore.updateSubCategory(props.id);
    bandwidthStore.calculateSliderConstants(props.state.amount);
    bandwidthStore.calculateValues();
    bandwidthStore.calculateTotalValues();
    bandwidthStore.calculateSavings();
  };

  return (
    <div className="col-xs-4 oui-inline">
      <a className={`profileButton title8 ${ props.buttonName.toLowerCase().includes(props.state.subCategory) ? 'activeTab' : '' }`} onClick={e => onClickHandler(props.id)}>{props.buttonName}</a>
    </div>
  );
};



export default ProfileButton;
